import type React from 'react';

type Props = {
    children?: React.ReactNode | React.ReactNode[];
};

export function TabContentTableWrapper({ children }: Props) {
    return <div className="flex w-full flex-col">{children}</div>;
}
